import { RouteRecordRaw } from 'vue-router';
import { RouteNames } from './types/routeNames';
import { RoutePaths } from './types/routePaths';
import AuthLayout from '@/layouts/AuthLayout.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: RoutePaths.root,
    redirect: RoutePaths.login,
  },
  {
    path: '/',
    component: AuthLayout,
    children: [
      {
        path: RoutePaths.login,
        name: RouteNames.login,
        component: () => import('@/pages/Login/LoginPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: RoutePaths.verifyEmail,
        name: RouteNames.verifyEmail,
        component: () => import('@/pages/VerifyEmail/VerifyEmailPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: RoutePaths.requestPasswordReset,
        name: RouteNames.requestPasswordReset,
        component: () => import('@/pages/RequestPasswordReset/RequestPasswordResetPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: RoutePaths.resetPassword,
        name: RouteNames.resetPassword,
        component: () => import('@/pages/ResetPassword/ResetPasswordPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/',
    component: DashboardLayout,
    children: [
      {
        path: RoutePaths.dashboard,
        name: RouteNames.dashboard,
        component: () => import('@/pages/Dashboard/DashboardPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: RoutePaths.pictures,
        name: RouteNames.pictures,
        component: () => import('@/pages/Pictures/PicturesPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: RoutePaths.guests,
        name: RouteNames.guests,
        component: () => import('@/pages/GuestList/GuestList.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: RoutePaths.guestsTable,
        name: RouteNames.guestsTable,
        component: () => import('@/pages/GuestTables/GuestTables.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: RoutePaths.admin,
        name: RouteNames.admin,
        component: () => import('@/pages/AdminDashboard/AdminDashboard.vue'),
        meta: {
          requiresAuth: true,
          requiredRoles: ['admin'],
        },
      },
      {
        path: RoutePaths.download,
        name: RouteNames.download,
        component: () => import('@/pages/DownloadDashboard/DownloadDashboard.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: RoutePaths.calculators,
        name: RouteNames.calculators,
        component: () => import('@/pages/CalculatorDashboard/CalculatorDashboard.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: RoutePaths.calculatorsPage,
        name: RouteNames.calculatorsPage,
        component: () => import('@/pages/CalculatorPage/CalculatorPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: RoutePaths.settings,
        name: RouteNames.settings,
        component: () => import('@/pages/Settings/SettingsPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

export const publicRoutes: string[] = [
  RoutePaths.login,
  RoutePaths.root,
  RoutePaths.verifyEmail,
  RoutePaths.requestPasswordReset,
  RoutePaths.resetPassword,
];

export const readonlyRoutes: string[] = [RoutePaths.pictures];

export const protectedRoutes: string[] = [
  RoutePaths.dashboard,
  RoutePaths.pictures,
  RoutePaths.guests,
  RoutePaths.guestsTable,
  RoutePaths.download,
  RoutePaths.calculators,
  RoutePaths.calculatorsPage,
  RoutePaths.settings,
];

export const adminRoutes: string[] = [RoutePaths.admin];

export const allAfterLoginRoutes = [...protectedRoutes, ...adminRoutes];
